export default __webpack_public_path__ + "static/media/000_intro_part2.first.b9553b43.png";